import React, { useEffect, useState } from 'react';
import { colors } from '../../../../colorVars';
import { checkSymbol } from '../../../../stores/websocketStore/utils/async/checkSymbol';
import style from './SymbolInput.module.css';
type Props = {
  stateSetterFunction: (value: string) => void;
  initialValue: string;
  brokerage: string;
  fontSize: string;
  color:
    | 'blue'
    | 'green'
    | 'white'
    | 'red'
    | 'grey'
    | 'lightGrey'
    | 'black'
    | 'orange'
    | 'yellow'
    | 'purple';
  backgroundColor:
    | 'blue'
    | 'green'
    | 'white'
    | 'red'
    | 'grey'
    | 'lightGrey'
    | 'black'
    | 'orange'
    | 'yellow'
    | 'purple';
  width?: string;
  margin?: string;
};

export const SymbolInput = ({
  stateSetterFunction,
  initialValue,
  brokerage,
  color,
  backgroundColor,
  fontSize,
  width,
  margin,
}: Props) => {
  const [inputValue, setInputValue] = useState('');

  const [isLegit, setIsLegit] = useState(true);

  const highLightClick = (e) => {
    e.target.select();
  };

  useEffect(() => {
    if (initialValue) setInputValue(initialValue);
  }, []);

  useEffect(() => {
    if (inputValue && inputValue !== '') {
      checkSymbol({ symbolString: inputValue, brokerage }).then((json) => {
        setIsLegit(!!json.exists);
        if (json.exists) stateSetterFunction(json.symbol);
      });
    }
  }, [inputValue, brokerage, stateSetterFunction]);
  return (
    <input
      placeholder="symbol..."
      style={{
        color: colors[color],
        backgroundColor: colors[backgroundColor],
        fontSize,
        width,
        margin,
      }}
      className={isLegit ? style.isLegit : style.isNotLegit}
      type="text"
      value={inputValue}
      onChange={({ target }) => setInputValue(target.value.toUpperCase())}
      onClick={highLightClick}
    />
  );
};
